module.exports = __webpack_public_path__ + "img/rules_18.61c0b19e.png";